
  <div [ngClass]="ccsClass">
 
    <div class="icon-position">
        <div class="icon-container">

            <mat-icon class="icon" [ngClass]="iconColorCss" aria-hidden="false">error_outline</mat-icon>
        </div>
    </div>
    <div class="notification-body">
        <div class="notification-body-title">{{title}}</div>
        <div class="notification-message" >{{this.message}}</div>
    </div>
    <div class="notification-close">
        <div class="iconbutton">
        <div class="icon-pos">
        <div class="closefilled">
            <mat-icon class="icon" (click)="close()" [ngClass]="iconColorCss" aria-hidden="false">close</mat-icon>
        </div>
        </div>
        </div>
        </div>
    </div>